import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                acl: {
                },
                url: {
                },
                iframe: {
                    domain: 'oeirasresolve.cm-oeiras.pt',
                    parent: 'https://oeirasresolve.cm-oeiras.pt', //'https://oeiras-resolve.municipia.pt',
                    // domain: 'oeiras-resolve.municipia.pt',
                    // parent: 'https://oeiras-resolve.municipia.pt', //'https://oeiras-resolve.municipia.pt',
                }
            },
            headernav: {
                tools: [
                ]
            },
        },
        tools: {
            zoom: {
                active: true,
            },
            attribution: {
                active: false,
            },
            scaleline: {
                active: false,
            },
            scalebox: {
                active: false,
            },
            mouseposition: {
                active: false,
            },
            geolocation: {
                active: false,
            },
            fullscreen: {
                active: false,
            },
            streetview: {
                active: false,
            },
            layers: {
                active: true,
                title: 'layers.title',
                label: 'layers.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: null,
                },
                url: {
                    getLayers: `${codeAPI}/front/map/layers`,
                },
            },
            catalog: {
                active: false,
            },
            print_visible_emissions: {
                active: false,
                title: 'print_visible_emissions.titles',
                label: 'print_visible_emissions.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: null,
                },
                url: {
                    capabilitiesPrint: `${codeAPI}/front/print/visible/capabilities`,
                    createPrint: `${codeAPI}/front/print/visible`,
                    getStatusPrint: `${codeAPI}/front/print/visible/job/:id`,
                }
            },
        },
        map: {
            loading: false,
            action: null,
            config: {
                layers: {
                },
                interactions: {
                    draw: {
                    },
                },
                style: {

                },
            }
        },
        config: {

        },
    },
};

export default state;